import { Grid, styled } from '@mui/material'

const InstallLayout = styled(Grid)({
    position: 'absolute',
    bottom: '0',
    top: '0',
    right: '0',
    left: '0',
    backgroundColor: 'rgba(16, 172, 132, 1)',
})
export default InstallLayout
